const Resources = () => import('Views/excellent/resources');
const Nanshazhudao = () => import('Views/excellent/nanshazhudao');
const Junshixinxi = () => import('Views/excellent/junshixinxi');
const Shishiyubao = () => import('Views/excellent/shishiyubao');

export default[
  { path: '/excellent/resources-headFull', component: Resources },
  { path: '/excellent/nanshazhudao-headFull', component: Nanshazhudao },
  { path: '/excellent/junshixinxi-headFull', component: Junshixinxi },
  { path: '/excellent/shishiyubao-headFull', component: Shishiyubao },
];



// WEBPACK FOOTER //
// ./src/router/excellent.js